// src/components/Carousel/Carousel.tsx
import React from "react";
import { ParallaxLayer } from "@react-spring/parallax";
import CarouselCard from "./BannerCard";
import type { BannerItem } from "../../models/banner.model";
import "./Banner.css";

interface BannerProps {
	offset: number;
	isFirstVisit: boolean;
	title: string;
	items: BannerItem[];
}

const Banner: React.FC<BannerProps> = ({ offset, isFirstVisit, title, items }) => (
	<ParallaxLayer
		offset={offset}
		style={{ overflow: "visible" }}
	>
		<div className="carousel-container">
			<div className="carousel-track">
				{/* Title Card */}
				<div className="carousel-card carousel-title-card">
					<div className="carousel-card-content-wrapper">
						<div className="carousel-card-text-container">
							<p className="carousel-card-description carousel-title-description">{title}</p>
						</div>
					</div>
				</div>

				{/* Data-driven Cards */}
				{items.map((item, idx) => (
					<CarouselCard
						key={idx}
						item={item}
						index={idx}
						isFirstVisit={isFirstVisit}
					/>
				))}
			</div>
		</div>
	</ParallaxLayer>
);

export default Banner;
